// vertical scroll to an element in a nav-bar
const scrollNav = (container, element, offset) => {
  const elementBoundingRect = element.getBoundingClientRect();
  const parentBoundingRect = container.getBoundingClientRect();

  //container bounds
  const leftNav = parseInt(parentBoundingRect.left);
  const rightNav = parseInt(parentBoundingRect.right);

  //nav-element bounds
  const elementLeftNav = parseInt(elementBoundingRect.left);
  const elementRightNav = parseInt(elementBoundingRect.right);

  // scroll
  let scrollByNav = 0;
  if (elementLeftNav < leftNav + offset) {
    scrollByNav = elementLeftNav - leftNav - offset;
  } else if (elementRightNav > rightNav - offset) {
    scrollByNav = elementRightNav - rightNav + offset;
  }
  if (scrollByNav !== 0) {
    container.scrollLeft += scrollByNav;
  }
};

const header = document.querySelector('#header');

//mapping of tab ids to individual active tab setter functions
const activeNavSetters = {};

const stickyNavBlocks = document.querySelectorAll('.stickyNavigationTabs-block');
stickyNavBlocks.forEach(block => {
  const nav = block.querySelector('nav');

  const tabs = {};
  const navItems = {};
  let activeId = '';

  //function for setting the active nav tab
  const setActiveTab = (id, callback = undefined, scroll = true) => {
    const tab = tabs[id];

    if (!tab) {
      console.warn('navigation tab (' + id + ') not found');
      return;
    }

    if (id !== activeId) {
      tabs[activeId].classList.remove('active');
      tab.classList.add('active');
      navItems[activeId].classList.remove('active');
      navItems[id].classList.add('active');
      activeId = id;

      window.dispatchEvent(new CustomEvent('setStickyNavigationTab'));
      window.dispatchEvent(new CustomEvent('setSliderMobile'));
      window.dispatchEvent(new Event('resize'));
    }

    if (scroll) {
      window.scrollToTarget(tab, { onScrollend: callback, offset: tab });
    }
  };

  nav.querySelectorAll('li').forEach(listItem => {
    //dom queries
    const link = listItem.querySelector('a');
    const id = link.getAttribute('href');
    const entry = document.querySelector(id);

    if (!entry) {
      console.warn('navigation tab (' + id + ') not found');
      return;
    }

    //filling the data-model
    tabs[id] = entry;
    navItems[id] = listItem;
    if (entry.classList.contains('active')) {
      activeId = id;
    }

    activeNavSetters[id] = (callback, scroll) => setActiveTab(id, callback, scroll);

    //event listener for clicking a nva item
    link.addEventListener('click', e => {
      e.preventDefault();
      setActiveTab(id);
      scrollNav(nav, listItem, 60);
    });
  });

  //logic for setting a fade effect if the navigation bar can be scrolled in a certain direction
  const setNav = () => {
    const width = block.querySelector('ul').offsetWidth - nav.offsetWidth;
    const scrollPercent = width > 0 ? (100 * nav.scrollLeft) / width : 0;
    const left = scrollPercent < 2 ? 0 : 1;
    const right = scrollPercent > 98 || width <= 0 ? 0 : 1;
    block.querySelector('.scroll').style.setProperty('--left-opacity', left);
    block.querySelector('.scroll').style.setProperty('--right-opacity', right);
  };

  nav.addEventListener('scroll', setNav);
  window.addEventListener('resize', setNav);
  document.addEventListener('DOMContentLoaded', setNav);
  window.addEventListener('customLoaded', setNav);
});

let setStickyNavigationTab = (id, callback = undefined, scroll = true) => {
  console.warn('no sticky navigation present');
};
if (stickyNavBlocks.length) {
  setStickyNavigationTab = (id, callback = undefined, scroll = true) => {
    activeNavSetters[id](callback, scroll);
  };

  function removeQueryFromUrl(qurl) {
    return qurl.split('?')[0];
  }

  let hash = removeQueryFromUrl(window.location.hash);

  if (hash.charAt(hash.length - 1) == '/') {
    hash = hash.substr(0, hash.length - 1);
  }

  if (hash && document.querySelectorAll(hash).length) {
    setStickyNavigationTab(hash);
  }

  document.querySelectorAll('[rel="tab:open"]').forEach(elem => {
    const url = new URL(elem.getAttribute('href'), window.location.href);
    const hash = url.hash;
    if (hash && activeNavSetters[hash]) {
      elem.addEventListener('click', e => {
        e.preventDefault();
        setStickyNavigationTab(hash);
      });
    }
  });
}

//temporary setup to make sure custom scripts keep working
window.setStickyNavigationTab = setStickyNavigationTab;
